import { Box, Button, Tab, TabList, TabPanels, Tabs } from '@chakra-ui/react';

import PageHeader from 'layout/pageHeader';
import { useTranslation } from 'helpers/languages/translations';
import { useState } from 'react';
import SalesDataTab from './components/molecules';
import { ArrowUpIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router';

const PATH = 'sales-data';
const ID = 'cdm_sales_data';
const NAME = 'page.salesData';

const SalesData = () => {
    const [tabIndex, setTabIndex] = useState(0);
    const translate = useTranslation();
    const navigate = useNavigate();

    const renderTabs = () => (
        <Tabs size="sm" onChange={(index) => setTabIndex(index)} index={tabIndex} isLazy>
            <TabList>
                <Tab _focus={{ boxshadow: 'none' }}>{translate('tab.sales-data')}</Tab>
            </TabList>
            <TabPanels>
                <SalesDataTab />
            </TabPanels>
        </Tabs>
    );

    return (
        <Box>
            <PageHeader icon={{ name: 'home' }} pageTitle={translate(NAME) as string}>
                <Button
                    onClick={() => navigate('upload')}
                    fontSize="14px"
                    h="30px"
                    bg={'white'}
                    variant="outline"
                    leftIcon={<ArrowUpIcon />}
                >
                    {translate('file.upload')}
                </Button>
            </PageHeader>
            <Box px="32px">{renderTabs()}</Box>
        </Box>
    );
};

export { ID, PATH, NAME };
export default SalesData;
